import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { UserService } from '../../../core/services/user.service';

@Directive({
    selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {

    @Input('hasPermission') roles: Array<any>;

    constructor(
        private el: ElementRef,
        private userService: UserService,
        private renderer: Renderer2
    ) {

    }

    ngOnInit() {
        this.checkUserRoles();
        const sub = this.userService.userIsLogin$.subscribe(
            () => {
                this.checkUserRoles();
            },
            () => {
            },
            () => {
                if (!isNullOrUndefined(sub)) {
                    sub.unsubscribe();
                }
            }
        );
    }

    private checkUserRoles() {
        const user: any = this.userService.user;
        const userRoles: Array<string> = user ? user.role : [];
        let canActivate = true;
        if (!isNullOrUndefined(this.roles) && this.roles.length) {
            this.roles.forEach((role) => {
                if (userRoles.indexOf(role) < 0) {
                    canActivate = false;
                }
            });
        }
        if (canActivate) {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
        } else {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }
    }
}
